












import { Component, Vue } from 'vue-property-decorator';
import RegisterForm from './components/RegisterForm.vue';
import { mapActions, mapGetters } from 'vuex';
import users from '@/store/modules/users';

@Component({
  components: {
    RegisterForm,
  },
})
export default class Register extends Vue {
  private errMessage = '';
  private loading = false;

  private async created() {
    try {
      const user = await users.getLoggedUser();
      if (!user) {
        await users.logout();
        this.$router.push({ name: 'login' });
      }
    } catch (error) {
      return error;
    }
  }

  private setError(err: string) {
    this.errMessage = err;
  }
}
